import React from 'react';
import styles from './TokenSettingsTab.module.css';
import { FieldRenderProps } from './types';
import KeyIndicator from './KeyIndicator';
import SecureInput from '../../../ui/SecureInput/SecureInput';

const TextCard: React.FC<FieldRenderProps> = ({ field, draft, initialDraft, showKeys, highlighted, saving, onTextChange }) => {
  const disabled = !!field.dependsOn && draft[field.dependsOn] !== 'true';
  const value = draft[field.key] ?? '';
  const isModified = value !== (initialDraft[field.key] ?? '');
  return (
    <div className={`${styles.card} ${disabled ? styles.cardDisabled : ''} ${highlighted ? styles.cardHighlight : ''}`}>
      <div className={styles.cardHeader}>
        <span className={styles.cardLabel}>
          {field.label}
          <KeyIndicator field={field} showKeys={showKeys} />
        </span>
        {isModified && <span className={styles.modifiedBadge}>Modified</span>}
      </div>
      <p className={styles.cardDescription}>{field.description}</p>
      <SecureInput
        fieldType="text"
        value={value}
        onChange={v => onTextChange(field.key, v)}
        placeholder={field.note}
        disabled={disabled || saving}
        autoComplete="off"
      />
      {disabled && field.dependsOn && (
        <p className={styles.disabledNote}>{field.disabledNote ?? 'Disabled while the setting above is off.'}</p>
      )}
    </div>
  );
};

export default TextCard;
